Cureus.SiqFooter= {}
//= require_tree ./SiqFooter